<form  autocomplete="off" [formGroup]="form">
  <div>
    <label class="required">GUDID string: </label>
    <br />
    <mat-form-field class="example-full-width" appearance="fill">
      <input type="text" placeholder="search device by GUDID" matInput formControlName="query">
    </mat-form-field>
    <button type="button" class="form-execute-buttons" color="primary" mat-raised-button (click)="filterDevicesByGUDID()">Filter</button>
  </div>
</form>
